<template xmlns:v-slot="http://www.w3.org/1999/html">
  <div class="kt-portlet">
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-label">
        <h3 class="kt-portlet__head-title">
          <i class="fal fa-bullseye-pointer mr-1"></i>
          Your Goals
          <small
            >Your goals will be send to you via your preferred channel.</small
          >
        </h3>
      </div>
    </div>
    <form class="kt-form kt-form--label-right">
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="kt-section__body">
            <v-card p-5>
              <v-card-text>
                <v-container class="kt-form">
                  <v-row>
                    <v-col cols="6" sm="12" md="6">
                      <v-textarea
                        solo
                        v-model="personal_goals"
                        name="personal_goals"
                        label="Start writing your personal goals..."
                      ></v-textarea>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="setPersonalGoals"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                    <v-col cols="6" sm="12" md="6">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">Goal</th>
                              <th class="text-left">Status</th>
                              <th class="text-left">Date Created</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in existing_goals" :key="item.id">
                              <td>{{ item.goal }}</td>
                              <td>{{ item.is_sent ? 'Sent' : 'Pending' }}</td>
                              <td>{{ item.created_at | displayDateTime }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      existing_goals: [],
      personal_goals: '',
    };
  },
  created() {
    this.fetchUserGoals();
  },
  methods: {
    fetchUserGoals() {
      this.$http.get(`/user-goal/${this.$auth.user().id}`).then((response) => {
        this.existing_goals = response.data.data;
      });
    },
    setPersonalGoals() {
      this.$validator.validate('*').then((result) => {
        if (result) {
          this.axios
            .post(`user-goal`, {
              goal: this.personal_goals,
            })
            .then(({ data }) => {
              this.existing_goals.push(data.new_goal);
              this.$notify('success', 'Your personal goal is saved!');
              this.personal_goals = '';
            });
        }
      });
    },
  },
};
</script>
